import { AnimatePresence, motion } from 'framer-motion'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import useInterval from '../../hooks/useInterval'
import logo from './logo.png'

const HeroSection = () => {
  const [currentAdjectiveIndex, setCurrentAdjectiveIndex] = useState(0)

  useInterval(() => {
    setCurrentAdjectiveIndex((prev) => (prev < 2 ? prev + 1 : 0))
  }, 1500)

  return (
    <section className='grid grid-cols-1 md:grid-cols-2 gap-4 items-center'>
      <article className='flex items-center justify-center'>
        <div className='p-6 md:p-10'>
          <h1 className='text-4xl md:text-5xl lg:text-6xl font-bold mb-10'>
            Do you want to maximize your revenue through effective and safe advertising?
          </h1>
          <p className='mb-4 md:text-2xl'>Poplink is the right tool for you!</p>
          <div>
            <Link to='/pricing'>
              <button className='p-2 rounded bg-black opacity-90 text-white'>Learn more</button>
            </Link>
          </div>
        </div>
      </article>
      <article className='flex items-center justify-center'>
        <div>
          <img src={logo} alt='Poplink logo' width={200} height={200} />
          <div className='text-center text-xl'>
            <h2>Ads should be</h2>
            <div className='relative'>
              <span>&nbsp;</span>
              <AnimatePresence>
                {currentAdjectiveIndex === 0 && (
                  <motion.div
                    className='font-bold text-blue-800 absolute top-0 w-full text-center'
                    initial={{ opacity: 0, left: -10 }}
                    animate={{ opacity: 1, left: 0 }}
                    exit={{ opacity: 0, left: 10 }}
                  >
                    contextual!
                  </motion.div>
                )}
              </AnimatePresence>
              <AnimatePresence>
                {currentAdjectiveIndex === 1 && (
                  <motion.div
                    className='font-bold text-blue-800 absolute top-0 w-full text-center'
                    initial={{ opacity: 0, left: -10 }}
                    animate={{ opacity: 1, left: 0 }}
                    exit={{ opacity: 0, left: 10 }}
                  >
                    engaging!
                  </motion.div>
                )}
              </AnimatePresence>
              <AnimatePresence>
                {currentAdjectiveIndex === 2 && (
                  <motion.div
                    className='font-bold text-blue-800 absolute top-0 w-full text-center'
                    initial={{ opacity: 0, left: -10 }}
                    animate={{ opacity: 1, left: 0 }}
                    exit={{ opacity: 0, left: 10 }}
                  >
                    awesome!
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <div className='font-semibold'>Privacy, check.</div>
            <div className='font-semibold'>Contextual ads, check.</div>
          </div>
        </div>
      </article>
    </section>
  )
}

export default HeroSection
